import { render, staticRenderFns } from "./TransfersCharts.component.vue?vue&type=template&id=141f5a5a&scoped=true&"
import script from "./TransfersCharts.component.vue?vue&type=script&lang=js&"
export * from "./TransfersCharts.component.vue?vue&type=script&lang=js&"
import style0 from "./TransfersCharts.component.vue?vue&type=style&index=0&id=141f5a5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141f5a5a",
  null
  
)

export default component.exports